import { Box } from 'components/common/box';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FlexContainer } from 'components/common';
import { FormSection } from 'components/common/form';
import {
  CalendarEventParticipantAddSelf,
  CalendarEventParticipantAddSelfUnauthenticated,
  CalendarEventParticipantRemoveSelf,
  CalendarEventRenderInfo
} from '.';

import type { GetCalendarEventAdditionalRenderingInfoRes } from 'shared-types/responses';

const CalendarEventMainView = () => {
  const {
    pageState: { calendarEvent },
    user
  } = useReduxState();

  const hasPrivileges =
    calendarEvent.visibility === 'public' ||
    calendarEvent.userIsOwner ||
    calendarEvent.userStatus === 'added' ||
    user?.roles.includes('superadmin');

  const { data, loading } =
    useApiData<GetCalendarEventAdditionalRenderingInfoRes>({
      allowUnauthenticatedUser: true,
      onlyIf: Boolean(calendarEvent?.id),
      url: `/admin/calendar-events/${calendarEvent?.id}/additional-info`
    });

  return (
    <div>
      <Box padding={0}>
        <div>
          <CalendarEventRenderInfo
            event={calendarEvent}
            eventAchievements={data?.achievements || []}
            eventCompetencies={data?.competencies || []}
            eventAttachments={data?.attachments || []}
            hasPrivileges={hasPrivileges}
            infoLoading={loading}
          />

          {calendarEvent.userIsOwner ||
          (calendarEvent.userStatus &&
            !calendarEvent.allowDeregistration) ? null : (
            <FormSection maxWidth="100%">
              <FlexContainer style={{ gap: 10, justifyContent: 'flex-end' }}>
                {calendarEvent.userStatus ? (
                  <CalendarEventParticipantRemoveSelf event={calendarEvent} />
                ) : user ? (
                  <CalendarEventParticipantAddSelf event={calendarEvent} />
                ) : (
                  <CalendarEventParticipantAddSelfUnauthenticated
                    event={calendarEvent}
                  />
                )}
              </FlexContainer>
            </FormSection>
          )}
        </div>
      </Box>
    </div>
  );
};

export default CalendarEventMainView;
